import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useListImages } from '../../../api/media'
import Icon from '../../atoms/Icon'
import { useMediaScope } from './useMediaScope'

function MediaImage ({
  levelTypeId,
  purposeCode,
  style,
  className,
  alt,
  levelId,
  defaultSrc
}) {
  const mediaScope = useMediaScope({ levelTypeId, levelId })
  const query = useMemo(() => {
    return {
      purpose: {
        purposeCode,
        ...mediaScope
      },
      take: 1
    }
  }, [purposeCode, mediaScope])
  const { data: images, isLoading } = useListImages(query)
  if (isLoading) return null
  if (!images?.data?.length && defaultSrc) {
    return (
      <img
        src={defaultSrc}
        alt={alt}
        style={style}
        className={className}
      />
    )
  }

  const image = images?.data?.at?.(0)
  return (
    image ? (
      <img
        src={image.imageUrl}
        alt={alt || image.description}
        style={style}
        className={className}
      />
    ) : (
      <div className={clsx('flex justify-center items-center border rounded', { ...style })} style={{ height: '96px' }}>
        <Icon name='image' customSize={48} />
      </div>
    )
  )
}

MediaImage.propTypes = {
  levelTypeId: PropTypes.number.isRequired,
  purposeCode: PropTypes.string.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  alt: PropTypes.string,
  levelId: PropTypes.number,
  defaultSrc: PropTypes.string
}

export default MediaImage
